export default "/press";
